import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getResources, Menu, translate } from 'react-admin';
import { Typography } from '@material-ui/core';

import { version } from '../../package.json';
import aph_logo from 'assets/aph_logo.png';
import xsquad_logo from 'assets/x-squad.png';
import xsquad_logo_svg from 'assets/x-squad.svg';

let AphMenu = props => {
  const {
    resources,
    onMenuClick,
    logout,
    open,
    dispatch,
    staticContext,
    translate,
    ...rest
  } = props;
  // console.log('open:', open);
  return !open ? (
    <Menu {...rest} />
  ) : (
    [
      <Menu key={1} {...rest} />,
      <div
        key={2}
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          marginTop: 20,
          marginBottom: 20,
          flex: 1
        }}
      >
        <Typography
          variant="caption"
          color="textSecondary"
          style={{
            textAlign: 'center',
            whiteSpace: 'pre-line',
            marginBottom: 10
          }}
        >
          {`version: ${version}`}
        </Typography>
        <div
          style={{
            // alignItems: "center",
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            width: '100%'
          }}
        >
          <div
            style={{
              // alignItems: "center",
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                textAlign: 'center',
                whiteSpace: 'pre-line',
                marginBottom: 10
              }}
            >
              &copy;
              {`Apolhygie`}
            </Typography>
            <img
              src={aph_logo}
              style={{ height: 60, objectFit: 'contain' }}
              alt="Apolhygie"
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                textAlign: 'center',
                marginBottom: 10
              }}
            >
              {translate('powered_by')}
            </Typography>
            <a href="http://x-squad.com">
              <img
                src={xsquad_logo}
                srcSet={xsquad_logo_svg}
                alt="X-Squad"
                style={{ height: 60, objectFit: 'contain' }}
              />
            </a>
          </div>
        </div>
      </div>
    ]
  );
};

const mapStateToProps = state => ({
  resources: getResources(state),
  open: state.admin.ui.sidebarOpen
});

AphMenu = translate(AphMenu);

export default withRouter(connect(mapStateToProps)(AphMenu));



// WEBPACK FOOTER //
// ./src/components/AphMenu.js